import styles from '../../home.less';

import React from 'react';
import { Row, Col, Dropdown, Statistic } from 'antd';

import customIcon from '../static/image/source-icon.png';
import { isMobile } from 'app/shared/util/screen-utils';
import Radar from 'app/shared/components/radar';

interface ISourceProp {
  data: string[];
}

export default class Source extends React.Component<ISourceProp, {}> {
  renderIcon(title) {
    return (
      <div>
        <i>
          <img src={customIcon} width={24} />
        </i>
        <span className={styles.icontitle}>{title}</span>
      </div>
    );
  }

  renderTitle() {
    return (
      <Row className={`${styles.rentTitle} ${styles.titleBorder}`}>
        <Col>{this.renderIcon('客户来源')}</Col>
      </Row>
    );
  }

  rederContain() {
    return <Radar data={this.props.data} />;
  }

  render() {
    return (
      <div className={`${styles.rent} ${styles.mt16} ${!isMobile() ? styles.ml16 : ''}`}>
        {this.renderTitle()}
        {this.rederContain()}
      </div>
    );
  }
}
